import { parseReleases } from '@shh/shared';
import notes from '../whats-new.md?raw';
import notesEn from '../whats-new.en.md?raw';
import { locale } from './locale';

/**
 * "Was ist neu": written once, for the family, in apps/web/src/whats-new.md and shown as it is.
 * Only what families notice in the app – the full internal history is docs/CHANGELOG.md.
 */
export { shortVersion, type Release } from '@shh/shared';

export const APP_VERSION = __APP_VERSION__;

// English (1.19) from its own file; versions before 1.19 exist only in German
export const releases = parseReleases(locale === 'en' ? notesEn : notes);
